/**
 * Pagination types for API requests and responses
 */
// Helper function to calculate pagination metadata
export function calculatePaginationMeta(page, limit, total) {
    const totalPages = Math.ceil(total / limit);
    return {
        page,
        limit,
        total,
        totalPages,
        hasNextPage: page < totalPages,
        hasPreviousPage: page > 1,
    };
}
// Helper function to calculate skip/offset for database queries
export function calculateSkip(page, limit) {
    return (page - 1) * limit;
}
// Default pagination values
export const DEFAULT_PAGE = 1;
export const DEFAULT_LIMIT = 10;
export const MAX_LIMIT = 100;
// Helper function to validate and normalize pagination parameters
export function normalizePaginationParams(params) {
    const page = Math.max(1, params.page || DEFAULT_PAGE);
    const limit = Math.min(MAX_LIMIT, Math.max(1, params.limit || DEFAULT_LIMIT));
    return { page, limit };
}
//# sourceMappingURL=Pagination.js.map